// extracted by mini-css-extract-plugin
export default {"root":"EditingNavBar__root--nf70T","save-notice":"EditingNavBar__save-notice--hqtzG","saveNotice":"EditingNavBar__save-notice--hqtzG"};